import React from 'react';
import Navbar from '../../../components/Navbar';
import HeroSection from '../../consulting/components/HeroSection';
import Footer from '../../consulting/components/Footer';
import './ApexLanding.css';
import '../../../components/Container.css';

const navbarLinks = [
  { to: '/', label: 'Consulting' },
  { to: '/platform', label: 'Platform' },
  { to: '/contact', label: 'Contact Us', isButton: true },
];

const footerSections = [
  {
    title: 'Company',
    links: [
      { to: '/', label: 'Consulting' },
      { to: '/platform', label: 'Platform' },
      { to: '/contact', label: 'Contact Us' },
    ],
  },
];

const ApexLanding: React.FC = () => {
  return (
    <div className="apex-app">
      <Navbar
        logo={{ src: '/orca-logo.png', text: 'Orca Labs' }}
        links={navbarLinks}
        overlay
      />

      <main>
        <HeroSection
          id="about"
          badge="Data Platform"
          title="Coming Soon"
          titleGradient=""
          description="We're building Apex, our all-in-one data platform for connecting, analyzing, and transforming your data. Check back soon — or get in touch if you'd like to learn more."
          primaryAction={{ label: 'Back to Consulting', to: '/' }}
          secondaryAction={{ label: 'Contact Us', href: '/contact' }}
        />
      </main>

      <Footer
        logo={{ src: '/orca-logo.png', text: 'Orca Labs' }}
        tagline="AI & data for Retail and CPG."
        sections={footerSections}
      />
    </div>
  );
};

export default ApexLanding;
